import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.hanscribe-access {
  --paper: #f2f0e9;
  --paper-deep: #e8e5dc;
  --surface: #fbfaf6;
  --ink: #1d2421;
  --ink-soft: #5f6863;
  --line: #d4d2c9;
  --line-strong: #b2b6b0;
  --green: #17483e;
  --green-dark: #0f352e;
  --green-pale: #e4ece8;
  --danger: #a63b34;
  --danger-pale: #f4e7e4;
  --radius-shell: 12px;
  --radius-control: 7px;
  --radius-compact: 5px;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: auto;
  background: var(--paper);
  color: var(--ink);
  font-family: Pretendard, "Noto Sans KR", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

.hanscribe-access,
.hanscribe-access * {
  box-sizing: border-box;
}

.hanscribe-access button,
.hanscribe-access input {
  font: inherit;
}

.access-masthead {
  display: flex;
  width: min(100% - 64px, 1200px);
  height: 80px;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  border-bottom: 1px solid var(--line);
}

.access-brand {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  gap: 12px;
  color: var(--ink);
  text-decoration: none;
}

.access-brand-mark {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border-radius: var(--radius-compact);
  background: var(--green);
  color: #fff;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 17px;
  line-height: 1;
}

.access-brand-name {
  font-size: 19px;
  font-weight: 750;
  letter-spacing: -0.025em;
}

.access-product-name {
  color: var(--ink-soft);
  font-size: 12px;
  font-weight: 650;
  letter-spacing: 0.04em;
}

.access-main {
  display: grid;
  min-height: calc(100vh - 80px);
  min-height: calc(100dvh - 80px);
  place-items: center;
  padding: 40px 32px 64px;
}

.access-stage {
  display: grid;
  width: min(100%, 1080px);
  min-height: 620px;
  grid-template-columns: minmax(300px, 0.82fr) minmax(460px, 1.18fr);
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: var(--radius-shell);
  background: var(--surface);
  box-shadow: 0 20px 60px rgba(29, 36, 33, 0.07);
  animation: access-in 280ms ease-out both;
}

.hanscribe-access.is-create .access-stage {
  width: min(100%, 1160px);
  min-height: 720px;
  grid-template-columns: minmax(280px, 0.7fr) minmax(620px, 1.3fr);
}

.access-context {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  background: var(--green);
  padding: 42px 38px 34px;
  color: #f6f3eb;
}

.access-context-rule {
  width: 42px;
  height: 3px;
  border-radius: 2px;
  background: #d9b75f;
}

.access-context-copy {
  position: relative;
  z-index: 1;
  margin: auto 0;
}

.access-context-kicker {
  margin: 0 0 18px;
  color: #b9ccc5;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.access-context-copy h2 {
  display: flex;
  max-width: 300px;
  flex-direction: column;
  margin: 0;
  font-size: clamp(32px, 3vw, 43px);
  font-weight: 600;
  line-height: 1.24;
  letter-spacing: -0.05em;
}

.access-context-copy h2 span {
  white-space: nowrap;
}

.access-context-scope {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 1px solid rgba(246, 243, 235, 0.2);
  padding-top: 16px;
  color: #b9ccc5;
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.03em;
}

.access-context-scope span {
  min-width: 0;
  text-align: center;
}

.access-context-scope span:first-child {
  text-align: left;
}

.access-context-scope span:last-child {
  text-align: right;
}

.access-auth-panel {
  display: flex;
  min-width: 0;
  flex-direction: column;
  background: var(--surface);
  padding: 56px 72px 24px;
}

.hanscribe-access.is-create .access-auth-panel {
  padding: 38px 58px 22px;
}

.access-auth-inner {
  width: 100%;
  max-width: 400px;
  margin: auto;
}

.hanscribe-access.is-create .access-auth-inner {
  max-width: 590px;
}

.access-auth-head {
  margin-bottom: 34px;
}

.access-auth-head::before {
  content: "";
  display: block;
  width: 32px;
  height: 2px;
  margin-bottom: 14px;
  border-radius: 2px;
  background: var(--green);
}

.access-auth-head h1 {
  margin: 0;
  color: var(--ink);
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.04em;
}

.access-auth-head p {
  margin: 8px 0 0;
  color: var(--ink-soft);
  font-size: 12px;
  line-height: 1.5;
}

.access-alert {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: -10px 0 22px;
  border-left: 2px solid var(--danger);
  border-radius: var(--radius-compact);
  background: var(--danger-pale);
  padding: 10px 12px;
  color: #7e2e29;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.55;
}

.access-alert svg {
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  margin-top: 1px;
}

.access-form,
.access-fields,
.access-form-section {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.access-form {
  gap: 24px;
  animation: access-form-in 180ms ease-out both;
}

.access-fields,
.access-form-section {
  gap: 18px;
}

.access-form--create {
  gap: 22px;
}

.access-form-section + .access-form-section {
  border-top: 1px solid var(--line);
  padding-top: 20px;
}

.access-section-heading,
.access-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.access-section-heading h2 {
  margin: 0;
  color: var(--ink);
  font-size: 13px;
  font-weight: 750;
  line-height: 20px;
}

.access-section-heading > span {
  color: var(--ink-soft);
  font-size: 12px;
  font-weight: 650;
}

.access-grid {
  display: grid;
  min-width: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.access-field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 7px;
}

.access-label {
  color: #404944;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
}

.access-text-link {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  color: var(--ink-soft);
  font-size: 12px;
  font-weight: 650;
  text-underline-offset: 3px;
}

.access-input-wrap {
  position: relative;
}

.access-input {
  width: 100%;
  min-width: 0;
  height: 48px;
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-control);
  background: #fff;
  padding: 0 13px;
  color: var(--ink);
  font-size: 14px;
  outline: none;
  transition: border-color 120ms ease, box-shadow 120ms ease, background-color 120ms ease;
}

.access-input-wrap .access-input {
  padding-right: 48px;
}

.access-input::placeholder {
  color: #6f756f;
}

.access-input:hover {
  border-color: #777f7a;
}

.access-input:focus {
  border-color: var(--green);
  box-shadow: 0 0 0 3px rgba(23, 72, 62, 0.1);
}

.access-input:-webkit-autofill {
  box-shadow: 0 0 0 1000px #fff inset;
  -webkit-text-fill-color: var(--ink);
}

.access-password-toggle {
  position: absolute;
  top: 2px;
  right: 2px;
  display: grid;
  width: 44px;
  height: 44px;
  place-items: center;
  border: 0;
  border-radius: var(--radius-compact);
  background: transparent;
  color: var(--ink-soft);
}

.access-password-toggle svg {
  width: 18px;
  height: 18px;
}

.access-password-toggle--text {
  color: var(--green);
  font-size: 11px;
  font-weight: 750;
}

.access-role-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-control);
  background: var(--paper);
  padding: 3px;
}

.access-role-option {
  height: 40px;
  border: 0;
  border-radius: var(--radius-compact);
  background: transparent;
  color: var(--ink-soft);
  font-size: 12px;
  font-weight: 700;
}

.access-role-option + .access-role-option {
  border-left: 1px solid var(--line);
}

.access-role-option.is-active {
  background: var(--surface);
  color: var(--green-dark);
  box-shadow: 0 0 0 1px var(--green) inset;
}

.access-button {
  display: inline-flex;
  width: 100%;
  height: 50px;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: var(--radius-control);
  padding: 0 16px;
  font-size: 13px;
  font-weight: 750;
  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease, box-shadow 160ms ease;
}

.access-button--primary {
  border-color: var(--green);
  background: var(--green);
  color: #fff;
  box-shadow: 0 6px 16px rgba(15, 53, 46, 0.14);
}

.access-button--primary:hover:not(:disabled) {
  border-color: var(--green-dark);
  background: var(--green-dark);
  box-shadow: 0 8px 20px rgba(15, 53, 46, 0.18);
}

.access-button--secondary {
  border-color: var(--line-strong);
  background: var(--surface);
  color: var(--ink);
  box-shadow: none;
}

.access-button--secondary:hover:not(:disabled) {
  border-color: #7f8781;
  background: #ffffff;
}

.access-button:disabled {
  cursor: not-allowed;
  border-color: var(--line);
  background: var(--paper-deep);
  color: #8e938f;
}

.access-button-state {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.access-button-state svg {
  width: 16px;
  height: 16px;
}

.access-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: access-spin 650ms linear infinite;
}

.access-mode-switch {
  display: flex;
  min-height: 36px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: -8px;
  color: var(--ink-soft);
  font-size: 12px;
}

.access-mode-switch a {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  color: var(--green);
  font-weight: 750;
  text-underline-offset: 3px;
}

.access-recovery {
  animation: access-form-in 180ms ease-out both;
}

.access-recovery-form,
.access-reset-form {
  gap: 20px;
}

.access-form-note {
  margin: -5px 0 0;
  color: var(--ink-soft);
  font-size: 12px;
  line-height: 1.65;
}

.access-state {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;
}

.access-state-icon {
  display: grid;
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  place-items: center;
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-control);
  background: var(--green-pale);
  color: var(--green);
  font-size: 17px;
  font-weight: 800;
}

.access-state-icon svg {
  width: 22px;
  height: 22px;
}

.access-state p {
  margin: 0;
  color: #424b46;
  font-size: 14px;
  line-height: 1.7;
}

.access-state--checking {
  min-height: 120px;
  flex-direction: row;
  align-items: center;
  gap: 14px;
}

.access-spinner--dark {
  border-color: rgba(23, 72, 62, 0.22);
  border-top-color: var(--green);
}

.access-state--invalid .access-state-icon {
  border-color: #d9aaa5;
  background: var(--danger-pale);
  color: var(--danger);
}

.access-status-note {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 5px;
  border-left: 2px solid #d9b75f;
  background: #f4f1e7;
  padding: 12px 14px;
  color: var(--ink-soft);
  font-size: 12px;
  line-height: 1.55;
}

.access-status-note strong {
  color: var(--ink);
  font-size: 11px;
}

.access-state-actions {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 10px;
}

.access-brand:focus-visible,
.access-text-link:focus-visible,
.access-mode-switch a:focus-visible,
.access-password-toggle:focus-visible,
.access-role-option:focus-visible,
.access-button:focus-visible {
  outline: 2px solid #c69a31;
  outline-offset: 2px;
}

@keyframes access-in {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes access-form-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes access-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .access-stage,
  .access-form,
  .access-recovery,
  .access-spinner {
    animation: none;
  }
}
@media (max-width: 900px) {
  .access-main {
    padding: 28px 24px 48px;
  }
  .access-stage,
  .hanscribe-access.is-create .access-stage {
    width: min(100%, 680px);
    min-height: 0;
    grid-template-columns: 1fr;
  }
  .access-context {
    min-height: 150px;
    padding: 26px 30px 22px;
  }
  .access-context-copy {
    margin: 24px 0 18px;
  }
  .access-context-kicker,
  .access-context-scope {
    display: none;
  }
  .access-context-copy h2 {
    max-width: none;
    flex-direction: row;
    gap: 0.3em;
    font-size: 25px;
    line-height: 1.25;
  }
  .access-auth-panel,
  .hanscribe-access.is-create .access-auth-panel {
    padding: 42px 48px 24px;
  }
  .access-auth-inner,
  .hanscribe-access.is-create .access-auth-inner {
    max-width: 580px;
  }
}
@media (max-width: 560px) {
  .hanscribe-access {
    background: var(--surface);
  }
  .access-masthead {
    width: calc(100% - 40px);
    height: 68px;
  }
  .access-product-name {
    display: none;
  }
  .access-main {
    display: block;
    min-height: calc(100dvh - 68px);
    padding: 0;
  }
  .access-stage,
  .hanscribe-access.is-create .access-stage {
    min-height: calc(100dvh - 68px);
    border: 0;
    border-radius: 0;
  }
  .access-context {
    min-height: 105px;
    padding: 18px 20px;
  }
  .access-context-rule {
    width: 30px;
    height: 2px;
  }
  .access-context-copy {
    margin: auto 0 0;
  }
  .access-context-copy h2 {
    max-width: none;
    font-size: 20px;
  }
  .access-auth-panel,
  .hanscribe-access.is-create .access-auth-panel {
    min-height: calc(100dvh - 173px);
    padding: 32px 20px 18px;
  }
  .access-auth-inner,
  .hanscribe-access.is-create .access-auth-inner {
    margin: 0 auto;
  }
  .access-auth-head {
    margin-bottom: 28px;
  }
  .access-auth-head h1 {
    font-size: 27px;
  }
  .access-alert {
    margin-left: 0;
  }
  .access-grid {
    grid-template-columns: 1fr;
  }
  .access-form--create {
    gap: 20px;
  }
  .access-input,
  .access-button {
    height: 48px;
  }
  .access-password-toggle {
    height: 44px;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public readonly defaultPath: string = '/hanscribe/encounters';
    public readonly publicSignupRoles: string[] = ['doctor', 'operator'];

    public mode: string = 'login';
    public showLoginPassword: boolean = false;
    public showCreatePassword: boolean = false;
    public showResetPassword: boolean = false;
    public showResetConfirmPassword: boolean = false;
    public loginData: any = {
        email: '',
        password: ''
    };
    public createData: any = {
        name: '',
        email: '',
        password: '',
        role: 'doctor',
        organization: '',
        department: ''
    };
    public recoverData: any = { email: '' };
    public resetData: any = { new_password: '', confirm_password: '' };

    public loginSubmitting: boolean = false;
    public createSubmitting: boolean = false;
    public recoverSubmitting: boolean = false;
    public recoverCompleted: boolean = false;
    public recoverMessage: string = '';
    public resetToken: string = '';
    public resetState: string = 'idle';
    public resetMessage: string = '';
    public resetChecking: boolean = false;
    public resetSubmitting: boolean = false;
    public errorMessage: string = '';

    public async ngOnInit() {
        await this.service.init();
        const params = new URLSearchParams(location.search);
        const requestedMode = params.get('mode');
        this.resetToken = (params.get('token') || '').trim();
        if (requestedMode === 'create' || requestedMode === 'signup') {
            this.mode = 'create';
        } else if (requestedMode === 'reset' && this.resetToken) {
            this.mode = 'reset';
        } else if (requestedMode === 'recover' || requestedMode === 'forgot') {
            this.mode = 'recover';
        } else {
            this.mode = 'login';
        }

        let check = await this.service.auth.check();
        if (check && this.mode !== 'recover' && this.mode !== 'reset') {
            location.href = this.defaultPath;
            return;
        }
        if (this.mode === 'reset') {
            await this.checkResetToken();
            return;
        }
        await this.service.render();
    }

    public async setMode(mode: string) {
        this.mode = mode === 'create' || mode === 'recover' || mode === 'reset' ? mode : 'login';
        this.errorMessage = '';
        if (this.mode !== 'recover') {
            this.recoverCompleted = false;
            this.recoverMessage = '';
        }
        if (this.mode !== 'reset') {
            this.resetToken = '';
            this.resetState = 'idle';
            this.resetMessage = '';
        }
        this.syncModeUrl();
        await this.service.render();
    }

    public async togglePassword(target: string) {
        if (target === 'create') {
            this.showCreatePassword = !this.showCreatePassword;
        } else if (target === 'reset') {
            this.showResetPassword = !this.showResetPassword;
        } else if (target === 'reset-confirm') {
            this.showResetConfirmPassword = !this.showResetConfirmPassword;
        } else {
            this.showLoginPassword = !this.showLoginPassword;
        }
        await this.service.render();
    }

    public async setCreateRole(role: string) {
        if (this.publicSignupRoles.indexOf(role) === -1) return;
        this.createData.role = role;
        this.errorMessage = '';
        await this.service.render();
    }

    private syncModeUrl() {
        try {
            const params = new URLSearchParams(location.search);
            if (this.mode === 'create' || this.mode === 'recover' || this.mode === 'reset') {
                params.set('mode', this.mode);
            } else {
                params.delete('mode');
            }
            if (this.mode === 'reset' && this.resetToken) {
                params.set('token', this.resetToken);
            } else {
                params.delete('token');
            }

            const query = params.toString();
            const nextUrl = `${location.pathname}${query ? '?' + query : ''}${location.hash || ''}`;
            history.replaceState(null, '', nextUrl);
        } catch (e) { }
    }

    public async login() {
        if (this.loginSubmitting) return;

        let user = JSON.parse(JSON.stringify(this.loginData));
        user.email = (user.email || '').trim().toLowerCase();

        if (!user.email) {
            await this.setError('이메일을 입력해주세요.');
            return;
        }
        if (!user.password) {
            await this.setError('비밀번호를 입력해주세요.');
            return;
        }

        this.loginSubmitting = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            let { code, data } = await wiz.call('login_scoped', user);
            if (code == 200) {
                location.href = (data && data.redirect) || this.defaultPath;
                return;
            }
            await this.setError((data && data.message) || '로그인에 실패했습니다.');
        } catch (e) {
            await this.setError('로그인 요청을 처리하지 못했습니다. 잠시 후 다시 시도해주세요.');
        } finally {
            this.loginSubmitting = false;
            await this.service.render();
        }
    }

    public async createAccount() {
        if (this.createSubmitting) return;

        let user = JSON.parse(JSON.stringify(this.createData));
        user.name = (user.name || '').trim();
        user.email = (user.email || '').trim().toLowerCase();
        user.role = (user.role || '').trim().toLowerCase();
        user.organization = (user.organization || '').trim();
        user.department = (user.department || '').trim();

        if (!user.name) {
            await this.setError('이름을 입력해주세요.');
            return;
        }
        if (!this.validEmail(user.email)) {
            await this.setError('업무 이메일을 정확히 입력해주세요.');
            return;
        }
        if (!user.password || user.password.length < 8) {
            await this.setError('비밀번호는 8자 이상으로 입력해주세요.');
            return;
        }
        if (this.publicSignupRoles.indexOf(user.role) === -1) {
            await this.setError('공개 계정 생성은 한의사 또는 원무/운영 역할만 가능합니다.');
            return;
        }
        if (!user.organization) {
            await this.setError('기관을 입력해주세요.');
            return;
        }
        if (!user.department) {
            await this.setError('부서를 입력해주세요.');
            return;
        }

        this.createSubmitting = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            let { code, data } = await wiz.call('create_account', user);
            if (code == 200) {
                location.href = (data && data.redirect) || this.defaultPath;
                return;
            }
            await this.setError((data && data.message) || '계정을 생성하지 못했습니다.');
        } catch (e) {
            await this.setError('계정 생성 요청을 처리하지 못했습니다. 잠시 후 다시 시도해주세요.');
        } finally {
            this.createSubmitting = false;
            await this.service.render();
        }
    }

    public pageTitle() {
        if (this.mode === 'create') return '계정 만들기';
        if (this.mode === 'recover') return this.recoverCompleted ? '이메일을 확인해 주세요' : '비밀번호 재설정';
        if (this.mode === 'reset') {
            if (this.resetState === 'ready') return '새 비밀번호 설정';
            if (this.resetState === 'success') return '변경 완료';
            if (this.resetState === 'pending') return '본인 확인 대기';
            return '비밀번호 재설정';
        }
        return '로그인';
    }

    public async restartRecovery() {
        this.recoverCompleted = false;
        this.recoverMessage = '';
        this.errorMessage = '';
        this.mode = 'recover';
        this.resetToken = '';
        this.resetState = 'idle';
        this.syncModeUrl();
        await this.service.render();
    }

    public async requestPasswordReset() {
        if (this.recoverSubmitting) return;
        const email = (this.recoverData.email || '').trim().toLowerCase();
        if (!this.validEmail(email)) {
            await this.setError('가입한 업무 이메일을 정확히 입력해 주세요.');
            return;
        }

        this.recoverSubmitting = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('request_password_reset', { email: email });
            if (code !== 200) {
                await this.setError((data && data.message) || data || '재설정 요청을 처리하지 못했습니다.');
                return;
            }
            this.recoverMessage = (data && data.message) || '';
            if (data && data.channel === 'admin' && data.continue_token) {
                this.resetToken = data.continue_token;
                this.resetState = 'pending';
                this.resetMessage = this.recoverMessage;
                this.mode = 'reset';
                this.syncModeUrl();
            } else {
                this.recoverCompleted = true;
            }
        } catch (e) {
            await this.setError('재설정 요청을 처리하지 못했습니다. 잠시 후 다시 시도해 주세요.');
        } finally {
            this.recoverSubmitting = false;
            await this.service.render();
        }
    }

    public async checkResetToken() {
        if (this.resetChecking || !this.resetToken) return;
        this.resetChecking = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('check_password_reset', { token: this.resetToken });
            this.resetState = code === 200 && data ? (data.state || 'invalid') : 'invalid';
            this.resetMessage = (data && data.message) || '재설정 링크를 확인하지 못했습니다.';
        } catch (e) {
            this.resetState = 'invalid';
            this.resetMessage = '재설정 링크를 확인하지 못했습니다.';
        } finally {
            this.resetChecking = false;
            await this.service.render();
        }
    }

    public async resetPassword() {
        if (this.resetSubmitting || this.resetState !== 'ready') return;
        const next = this.resetData.new_password || '';
        const confirm = this.resetData.confirm_password || '';
        if (next.length < 8) {
            await this.setError('새 비밀번호는 8자 이상으로 입력해 주세요.');
            return;
        }
        if (next !== confirm) {
            await this.setError('새 비밀번호가 일치하지 않습니다.');
            return;
        }

        this.resetSubmitting = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('reset_password', {
                token: this.resetToken,
                new_password: next,
                confirm_password: confirm
            });
            if (code !== 200) {
                await this.setError((data && data.message) || data || '비밀번호를 변경하지 못했습니다.');
                return;
            }
            this.resetData = { new_password: '', confirm_password: '' };
            this.resetState = 'success';
            this.resetMessage = (data && data.message) || '비밀번호가 변경되었습니다.';
        } catch (e) {
            await this.setError('비밀번호를 변경하지 못했습니다. 잠시 후 다시 시도해 주세요.');
        } finally {
            this.resetSubmitting = false;
            await this.service.render();
        }
    }

    private validEmail(email: string) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || '');
    }

    private async setError(message: string) {
        this.errorMessage = message;
        await this.service.render();
    }
}

export default PageAccessComponent;